import httpCommon from "@/http-common";

class CardManagerService {

    findAllCard(cardNumber, usageStatus, idSchool, limit, page) {
        return httpCommon.get(`/webhook/card-manager/search`, {params: {cardNumber, usageStatus, idSchool, limit, page}});
    }

    getListDeviceRecognition() {
        return httpCommon.get(`/webhook/card-manager/device/all`);
    }

    getInformationNumberCard(idDevice){
        return httpCommon.get(`/webhook/card-manager/read-card`,{params: {idDevice}});
    }
    checkNumberCardAllDeviceRecognition(number){
        return httpCommon.get(`/webhook/card-manager/check/${number}`);
    }
    createCardRecognition(data){
        return httpCommon.post(`/webhook/card-manager/create`,data);
    }

    deleteCard(id){
        return httpCommon.delete(`/webhook/card-manager/delete/${id}`);
    }
    deleteListCard(list){
        return httpCommon.delete(`/webhook/card-manager/delete/many/${list}`);
    }

    activeCard(id){
        return httpCommon.post(`/webhook/card-manager/active/${id}`);
    }
    activeListCard(list){
        return httpCommon.post(`/webhook/card-manager/active/many/${list}`);
    }

    deActiveCard(id){
        return httpCommon.post(`/webhook/card-manager/de-active/${id}`);
    }
    deActiveListCard(list){
        return httpCommon.post(`/webhook/card-manager/de-active/many/${list}`);
    }


}
export default new CardManagerService();